import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

export default function ReportModal({
    open,
    onClose,
    title,
    htmlContent,
    direction
}) {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                sx: {
                    height: '90vh',
                    maxHeight: '90vh',
                    borderRadius: '12px',
                    overflow: 'hidden'
                }
            }}
        >
            <DialogTitle
                sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    py: 2,
                    px: 3
                }}
            >

                <IconButton
                    onClick={onClose}
                    sx={{
                        color: 'white',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.1)'
                        }
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
                    {title}
                </Typography>
            </DialogTitle>

            <DialogContent
                sx={{
                    p: 0,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                        overflow: 'auto',
                        '& iframe': {
                            width: '100%',
                            height: '100%',
                            border: 'none'
                        }
                    }}
                >
                    {htmlContent && (
                        <iframe
                            srcDoc={htmlContent}
                            title={title}
                            style={{
                                width: '100%',
                                height: 'calc(90vh - 120px)',
                                border: 'none'
                            }}
                        />
                    )}
                </Box>
            </DialogContent>

            <DialogActions
                sx={{
                    background: '#f8f9fa',
                    borderTop: '1px solid #e0e0e0',
                    px: 3,
                    py: 2
                }}
            >
                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        borderRadius: '8px',
                        px: 3,
                        py: 1,
                        textTransform: 'none',
                        fontWeight: 600,
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        '&:hover': {
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)'
                        }
                    }}
                >
                    {t('close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
